function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as analytics from '@adsk/acs-web-analytics';
import Avatar from '@adsk/alloy-react-avatar';
import { BasicButton } from '@adsk/alloy-react-button';
import { TriangleUpIcon, TriangleDownIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';
import Tooltip, { Flyout } from '@adsk/alloy-react-tooltip';
import SubscriptionsModal from '@adsk/alloy-subscriptions-modal';
import Profile from './Profile';
import ProfileLoader from './ProfileLoader';
import { ANALYTICS_TYPES } from '../helpers/analytics';
import { userShape } from '../helpers/propTypes';
/**
 * Acs ProfileButton
 */
const ProfileButton = _ref => {
  let {
    showSubscriptionsModal,
    user,
    projectId,
    onLogout,
    UNSAFE_showBuildersUserProfileModal,
    UNSAFE_isBuildersProfileModalEnabled
  } = _ref;
  const [menuOpen, setMenuOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const TriangleIconComponent = menuOpen ? TriangleUpIcon : TriangleDownIcon;
  return user ? /*#__PURE__*/React.createElement(Flyout, {
    show: menuOpen,
    onHide: () => setMenuOpen(false),
    onShow: () => setMenuOpen(true),
    placement: Flyout.PLACEMENTS.BOTTOM_END,
    renderTarget: props => /*#__PURE__*/React.createElement(Tooltip.Target, props),
    content: /*#__PURE__*/React.createElement(Profile, {
      user: user,
      projectId: projectId,
      onLogout: onLogout,
      onClose: () => setMenuOpen(false),
      UNSAFE_showBuildersUserProfileModal: UNSAFE_showBuildersUserProfileModal,
      UNSAFE_isBuildersProfileModalEnabled: UNSAFE_isBuildersProfileModalEnabled,
      onOpenSubscriptions: () => setModalOpen(true),
      showSubscriptionsModal: showSubscriptionsModal
    }),
    offset: 20,
    renderBody: props => /*#__PURE__*/React.createElement(Tooltip.Body, _extends({}, props, {
      padding: 0
    })),
    getTargetProps: () => ({
      style: {
        display: 'flex',
        alignSelf: 'center'
      }
    })
  }, /*#__PURE__*/React.createElement(BasicButton, {
    onClick: () => {
      setMenuOpen(!menuOpen);
      analytics.track(ANALYTICS_TYPES.TOPNAVIGATION_USERAREA_CLICK);
    },
    "data-testid": "TopNavigation__user",
    style: {
      margin: 0,
      padding: 0,
      color: theme.colors.charcoal900,
      '&:hover': {
        color: theme.colors.charcoal700
      }
    }
  }, /*#__PURE__*/React.createElement(Avatar, {
    image: user.imageUrl,
    size: Avatar.SIZES.MEDIUM_24,
    name: user.name ? user.name : undefined
  }), /*#__PURE__*/React.createElement(TriangleIconComponent, {
    style: {
      color: theme.colors.charcoal700,
      flexShrink: 0,
      marginLeft: 4
    },
    size: 20
  })), showSubscriptionsModal && isModalOpen && /*#__PURE__*/React.createElement(SubscriptionsModal, {
    onCloseModal: () => setModalOpen(false)
  })) : /*#__PURE__*/React.createElement(ProfileLoader, null);
};
ProfileButton.displayName = 'ProfileButton';
ProfileButton.propTypes = {
  /** show subscriptions modal (page level) */
  showSubscriptionsModal: PropTypes.bool,
  /** current user */
  user: userShape,
  /** current selected project id */
  projectId: PropTypes.string,
  /** callback called on logout */
  onLogout: PropTypes.func,
  /** Triggers opening the Builders Network Profile Modal */
  UNSAFE_showBuildersUserProfileModal: PropTypes.func,
  /** When BuildersNetworkProfile is enabled, it updates the TopNav Profile dropdown options to include button for opening the BN Modal and hides the Profile settings button*/
  UNSAFE_isBuildersProfileModalEnabled: PropTypes.bool
};
export default ProfileButton;
//# sourceMappingURL=ProfileButton.js.map